// src/api/aics/kbDocRichEditor.js
import { LOCAL_API_URL,http } from "../base";

// 创建图文文档
export async function createEditorDoc(data) {
    console.log("createEditorDoc", data);
    
    // 同样处理 imageReferences
    let processedData = { ...data };
    
    if (processedData.imageReferences && typeof processedData.imageReferences === 'string') {
        try {
            processedData.imageReferences = JSON.parse(processedData.imageReferences);
            console.log("已解析 imageReferences:", processedData.imageReferences);
        } catch (e) {
            console.warn("解析 imageReferences 失败:", e);
            processedData.imageReferences = null;
        }
    }
    
    const response = await http.post(
        `/aics/kb-docs/editor`,
        processedData,
        {
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            }                
        })
    return response;        
}    

// 更新图文文档
export async function updateEditorDoc(id, data) {
    console.log("updateEditorDoc", id, data);
    
    // 处理 imageReferences：如果它是字符串，尝试解析为数组
    let processedData = { ...data };
    
    if (processedData.imageReferences && typeof processedData.imageReferences === 'string') {
        try {
            processedData.imageReferences = JSON.parse(processedData.imageReferences);
            console.log("已解析 imageReferences:", processedData.imageReferences);
        } catch (e) {
            console.warn("解析 imageReferences 失败:", e);
            // 如果解析失败，设置为空数组或 null
            processedData.imageReferences = null;
        }
    }
    
    const response = await http.post(
        `/aics/kb-docs/editor`,  // 使用相同的路径
        {
            ...processedData,
            id: id  // 添加 id 到请求体
        },
        {
            headers: { 
                'Content-Type': 'application/json;charset=utf-8'
            }    
        }
    );
    return response;
}

// 获取图文文档详情
export async function getEditorDoc(id) {
    console.log("getEditorDoc", id);
  const response = await http.get(
    `${LOCAL_API_URL}/aics/kb_doc/api/kb-docs/editor/${id}`,    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
    console.log(response);
    // 统一处理响应格式
    if (response==null || response.status !== 200) {
      throw new Error(response.data.message || '获取图文文档详情失败');
    }
    return response.data;
}

// 删除图文文档
export function deleteEditorDoc(id) {
  return http.delete(
     `${LOCAL_API_URL}/api/kb-docs/editor/${id}`,
   );    
}

export function getEditorDocWithRefreshedImages(id) {
  return http.get('/aics/kb-docs/editor/with-refreshed-images?id='+id)
}